import initSlider from '../libs/initSlider';
import loadYoutubeScript from '../libs/loadYoutubeScript';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  loadYoutubeScript();

  const reviewsTabsSlider = initSlider('[data-reviews-tabs-slider]', {
    ...tabsSliderOptions,
    centeredSlides: false,
  });
  const reviewsSlider = initSlider('[data-reviews-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: reviewsTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  /*  */

  const servicesTabsSlider = initSlider('[data-services-tabs-slider]', tabsSliderOptions);
  const servicesSlider = initSlider('[data-services-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: servicesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });
});
